import { gql } from 'graphql-request';
import { useQuery } from '@tanstack/react-query';
import AppError from '../../../../app/features/error/services/AppError';
import useGraphQLClient from '../../../../app/hooks/useGraphQLClient';
import { useAuthContext } from '../../../auth/contexts/AuthContext';
import IInvestExpertiseFilters from '../../interfaces/expertise/IInvestExpertiseFilters';
import IInvestExpertiseHistoryByFundByInvestor from '../../interfaces/expertise/history/IInvestExpertiseHistoryByFundByInvestor';
import { useAppNavigationContext } from '../../../../app/features/navigation/providers/AppNavigationProvider';

const useInvestExpertiseHistoryByFundByInvestor = (filters: IInvestExpertiseFilters) => {
	const auth = useAuthContext();
	const navigationContext = useAppNavigationContext();
	const graphQLClient = useGraphQLClient();
	const filter = {
		typeTag: filters.typeTag,
		fundIds: filters.fundIds,
		investorIds: filters.investorIds,
		// investmentYear: filters.investmentYear,
		// reportingPeriod: filters.reportingPeriod,
		// vintage: filters.vintage,
		// isRealized: filters.isRealized,
		// sfdr: filters.sfdr,
		// domainTag: filters.domainTag,
		currency: navigationContext.currentCurrency,
	};
	const { data } = useQuery(
		['expertiseHistoryByFundByInvestor', filter],
		async () => {
			try {
				const data = (await graphQLClient.request(
					gql`
						query (
							$typeTag: String
							$fundIds: [Int]
							$currency: String
							$investorIds: [Int] # $investmentYear: Int # $reportingPeriod: String # $vintage: Int # $isRealized: Boolean # $sfdr: String # $domainTag: String
						) {
							expertiseHistoryByFundByInvestor(
								typeTag: $typeTag
								fundIds: $fundIds
								currency: $currency
								investorIds: $investorIds # investmentYear: $investmentYear # reportingPeriod: $reportingPeriod # vintage: $vintage # isRealized: $isRealized # sfdr: $sfdr # domainTag: $domainTag
							) {
								funds {
									date
									period {
										year
										quarter
										name
									}
									fundId
									totalValue
									netCalledCapital
									currency
									investorId
								}
							}
						}
					`,
					filter,
				)) as { expertiseHistoryByFundByInvestor: IInvestExpertiseHistoryByFundByInvestor };
				return data.expertiseHistoryByFundByInvestor;
			} catch (e) {
				throw new AppError(e, 'useInvestExpertiseHistoryByFundByInvestor');
			}
		},
		{
			enabled:
				!!filter.fundIds &&
				auth.currentCompany !== null &&
				auth.isInvestor === true &&
				auth.isAuthenticated &&
				navigationContext.currentCurrency !== null,
		},
	);
	return data ?? null;
};

export default useInvestExpertiseHistoryByFundByInvestor;
